import * as React from "react";

export default function RequiredAsterisk() {
  return (
    <span className="text-danger">*</span>

  );
}